module.exports = __webpack_public_path__ + "img/mtn_logo.05aec86c.svg";